import React, { SVGProps } from "react";

const SvgProtrusion03 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="#2681b4"
      d="m267.472 143.588-77.849-30.801-80.245-46.211 158.094 77.012z"
    />
    <path
      fill="#45e0ff"
      d="M109.378 66.345v171.603l80.245-125.161-80.245-46.442z"
    />
    <path
      fill="#b5c7d4"
      d="M189.623 112.787 121.41 219.179l133.908-80.397-65.695-25.995z"
    />
    <g fill="none" stroke="#002839" strokeLinejoin="round" strokeWidth={2}>
      <path d="m109.378 66.345 80.245 46.442-80.245 125.161V66.345zM109.378 66.345l158.094 77.243-77.849-30.801" />
    </g>
    <path
      fill="none"
      stroke="#3f3f3f"
      strokeMiterlimit={10}
      d="m122.004 218.01 133.314-79.228"
    />
  </svg>
);

export default SvgProtrusion03;
